import { AppSettings } from '../../proyect.conf';

export type NivelLog = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'OFF';

const SEVERIDAD: Record<NivelLog, number> = {
  DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3, OFF: 4
};

function obtenerNivelConfigurado(): NivelLog {
  // Cambiado para leer desde AppSettings unificado
  const nivelStr = (AppSettings.loggingLevel || 'INFO').toUpperCase();
  if (nivelStr in SEVERIDAD) {
    return nivelStr as NivelLog;
  }
  return 'INFO';
}

export function inicializarLogger(): void {
  try {
    const consoleObj = console;
    if (!consoleObj) return;

    const originalDebug = consoleObj.debug || consoleObj.log;
    const originalLog = consoleObj.log;
    const originalInfo = consoleObj.info || consoleObj.log;
    const originalWarn = consoleObj.warn;
    const originalError = consoleObj.error;

    const debeImprimir = (nivelRequerido: NivelLog): boolean => {
      const nivelConfigurado = obtenerNivelConfigurado();
      return SEVERIDAD[nivelRequerido] >= SEVERIDAD[nivelConfigurado];
    };

    consoleObj.debug = function(...args: any[]) { if (debeImprimir('DEBUG')) originalDebug.apply(consoleObj, args); };
    consoleObj.log = function(...args: any[]) { if (debeImprimir('INFO')) originalLog.apply(consoleObj, args); };
    consoleObj.info = function(...args: any[]) { if (debeImprimir('INFO')) originalInfo.apply(consoleObj, args); };
    consoleObj.warn = function(...args: any[]) { if (debeImprimir('WARN')) originalWarn.apply(consoleObj, args); };
    consoleObj.error = function(...args: any[]) { if (debeImprimir('ERROR')) originalError.apply(consoleObj, args); };

  } catch (error) {
    if (console && console.warn) {
      console.warn('No se pudo inicializar la intercepción de console: ', (error as Error).message);
    }
  }
}
